import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "btn-container d-flex align-items-center justify-content-end py-16" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-add me-12" }, null, -1)
const _hoisted_3 = {
  key: 1,
  class: "table-responsive mb-16"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", { class: "fit" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon icon-blank-alt-light fw-bold" })
], -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  colspan: "222222",
  class: "empty-state py-8 px-12 text-center"
}
const _hoisted_7 = { class: "h-100 w-100 d-flex flex-column align-items-center justify-content-center text-center" }
const _hoisted_8 = { class: "h5 title text-primary" }
const _hoisted_9 = { class: "fit text-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-view-light fw-bold" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_button = _resolveComponent("v-button")!
  const _component_the_patient_document_upload = _resolveComponent("the-patient-document-upload")!
  const _component_v_table_header = _resolveComponent("v-table-header")!
  const _component_v_table_body = _resolveComponent("v-table-body")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_loader = _resolveComponent("v-loader")!
  const _component_the_patient_document_show_modal = _resolveComponent("the-patient-document-show-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.can('patient.expedient.file.store'))
        ? (_openBlock(), _createBlock(_component_v_button, {
            key: 0,
            variant: "secondary",
            "aria-label": _ctx.$t('Añadir documento'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAddMedia = !_ctx.showAddMedia))
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('Añadir documento')), 1)
            ]),
            _: 1
          }, 8, ["aria-label"]))
        : _createCommentVNode("", true)
    ]),
    (!!_ctx.showAddMedia)
      ? (_openBlock(), _createBlock(_component_the_patient_document_upload, {
          key: 0,
          onMediaConfirm: _ctx.mediaConfirm
        }, null, 8, ["onMediaConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.status === 'loaded')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_v_table, { class: "table-bordered" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_table_header, null, {
                default: _withCtx(() => [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('Fecha')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('Nombre')), 1),
                    _hoisted_4
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_table_body, null, {
                default: _withCtx(() => [
                  (!_ctx.media.length)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                        _createElementVNode("td", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('No hay documentos de esta categoría')), 1)
                          ])
                        ])
                      ]))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.media, (file) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: file.id
                        }, [
                          _createElementVNode("td", null, _toDisplayString(file.createdAt), 1),
                          _createElementVNode("td", null, _toDisplayString(file.name), 1),
                          _createElementVNode("td", _hoisted_9, [
                            _createVNode(_component_v_button, {
                              variant: "icon",
                              class: "p-0 m-auto",
                              onClick: ($event: any) => {_ctx.currentMedia = file; _ctx.modalToShow = 'the-patient-document-show-modal'}
                            }, {
                              default: _withCtx(() => [
                                _hoisted_10
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ]))
                      }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createBlock(_component_v_loader, { key: 2 })),
    (_ctx.modalToShow === 'the-patient-document-show-modal')
      ? (_openBlock(), _createBlock(_component_the_patient_document_show_modal, {
          key: 3,
          media: _ctx.currentMedia,
          onClosed: _cache[1] || (_cache[1] = ($event: any) => {_ctx.modalToShow = null; _ctx.currentMedia = null})
        }, null, 8, ["media"]))
      : _createCommentVNode("", true)
  ], 64))
}